import React, { useState, useEffect } from "react";
// import doctor from "../images/doctor.jpg";
import doctor from "../images/doctorAvtar.png";
import NavigateNextSharpIcon from "@mui/icons-material/NavigateNextSharp";
import { Link, useLocation, useParams } from "react-router-dom";
import { format, parse } from "date-fns";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDoctorDetails, setPatientDetails } from "../reduxtool/action";
import axios from "axios";
import { decryptData } from "../Services/TabServices";

const DoctorCheckOut = () => {
  const token = sessionStorage.getItem("token");
  const storedUserId = sessionStorage.getItem("userId");
const userId = storedUserId ? decryptData(storedUserId) : null;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch: any = useDispatch();
  const { doctorId, bookingDate, bookingTime, selectedSlotId } =
    location.state || {};
  const patient = useSelector((state: any) => state.userDetails);
  const doctorDetail = useSelector((state: any) => state.selectedDoctorDetails);
  const [age, setAge] = useState<any>(" ");
  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = useState<any>(" ");
  const [isLoading, setIsLoading] = useState(false);
  const [popupMessage, setPopupMessage] = useState<string | null>(null);
  const formattedDate = bookingDate
    ? format(new Date(bookingDate), "dd MM yyyy")
    : "N/A";
  const formattedTime = bookingTime
    ? format(parse(bookingTime, "HH:mm:ss", new Date()), "hh:mm a")
    : "N/A";

  const calculateAge = (dobString: string): string => {
  if (!dobString) return "";
  const dob = new Date(dobString);
  const today = new Date();

  let years = today.getFullYear() - dob.getFullYear();
  let months = today.getMonth() - dob.getMonth();
  let days = today.getDate() - dob.getDate();

  if (days < 0) {
    months -= 1;
    const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += prevMonth.getDate();
  }

  if (months < 0) {
    years -= 1;
    months += 12;
  }

  // Always show years, months, and days
  return `${years} year${years !== 1 ? 's' : ''} ${months} month${months !== 1 ? 's' : ''} ${days} day${days !== 1 ? 's' : ''}`;
};

  useEffect(() => {
    if (!patient) {
      dispatch(setPatientDetails(token, userId));
    }
  }, [dispatch, patient]);

  useEffect(() => {
    if (doctorId) {
      dispatch(setDoctorDetails(doctorId));
    }
  }, [dispatch, doctorId]);

  useEffect(() => {
    if (patient?.dob) {
      const calculatedAge = calculateAge(patient.dob);
      setAge(calculatedAge);
    }
  }, [patient, calculateAge]);


 
  
  // const handleClick = () => {
  //   if (!isChecked) {
  //     setError("Please accept the terms and conditions before booking.");
  //     return;
  //   }
  //   if (!token) {
  //     navigate("/login");
  //     return;
  //   }

  //   navigate("/doctorCheckoutPayment", {
  //     state: {
  //       bookingDate: bookingDate,
  //       doctorId: doctorId,
  //       doctorFee: doctorDetail[0]?.doctorFees,
  //       bookingTime: bookingTime,
  //       selectedSlotId: selectedSlotId,
  //     },
  //   });
  // };


  
    const handleClick = async () => {
    if (!isChecked) {
      alert("Please accept the terms and conditions before booking.");
      return;
    }

    if (!token) {
      navigate("/login");
      return;
    }
 setIsLoading(true); 
    try {
    
    const payload ={
    patientId: userId,
    doctorId: doctorId,
    AppointmentDate: bookingDate,
    slotId: selectedSlotId,
    paidAmount: doctorDetail[0]?.doctorFees
    }

 
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/PhonePe/initiate-pay`,
        payload,
     );
     const redirectUrl=response.data.redirectUrl
      if(redirectUrl){
        window.location.href = `${redirectUrl}`;
      } else {
        setPopupMessage(" Payment initialization failed. Please try again.");
      }
    }catch(err){
      console.error("Payment initiation error:", err);
      setPopupMessage(" Something went wrong during payment. Try again later.");
    }finally{
      setIsLoading(false); 
    }
  };

  return (
    <div className="">
      <div className=" bg-white w-full z-20  pb-2 pl-2">
        <div className="text-black text-lg sm:text-xl md:text-2xl font-medium">
          Top Doctor
        </div>
        <div className="px-2 flex items-center flex-wrap">
          {/* <Link
            className="text-gray-600 text-[12px] sm:text-base font-medium no-underline"
            to="/"
          >
            Home
          </Link>
          <NavigateNextSharpIcon /> */}

          {/* <Link
            className="text-gray-600 text-[12px] sm:text-base font-medium no-underline"
            to="/specialities"
          >
            Specialities
          </Link>
          <NavigateNextSharpIcon /> */}

          <Link
            className="text-[#009A85] text-[12px] sm:text-base font-medium no-underline"
            to="/doctors"
          >
            Doctors
          </Link>
        </div>
      </div>

      <div className="flex flex-col md:flex-row justify-between gap-2 w-[98%]">
       {popupMessage && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50 transition-all">
    <div className="bg-white rounded-2xl shadow-2xl p-6 w-[320px] text-center transform animate-scaleIn">
     

      {/* Message */}
      <p className="text-gray-800 text-base font-medium">{popupMessage}</p>

      {/* Button */}
      <button
        onClick={() => setPopupMessage(null)}
        className="mt-5 w-full px-4 py-2.5 bg-[#009A85] text-white rounded-xl font-medium shadow-md hover:bg-[#007d6e] transition"
      >
        OK
      </button>
    </div>
  </div>
)}

        <div className="w-[100%] lg:w-[97%] p-2 px-5 bg-white rounded-xl">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Selected Doctor */}
            <div className="p-4 border rounded-lg">
              <h3 className="text-center text[14px] text-[#606060] font-semibold mb-2">
                Selected Doctor
              </h3>
              <div className="flex items-center gap-20">
                {/* <img
             src={doctor} 
                  alt="Doctor"
                  className="w-20 h-20 rounded-full"
                /> */}
                {doctorDetail[0]?.doctorImage !== null ? (
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}/${doctorDetail[0]?.doctorImage}`}
                    alt="Doctor"
                    style={{
                      height: "100px",
                      width: "90px",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                  />
                ) : (
                  <img
                    src={doctor}
                    alt="Doctor"
                    style={{
                      height:"100px",
                      width:"100px",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                  />
                )}
                <div>
                  <p className="font-semibold">{doctorDetail[0]?.doctorName}</p>
                  <p className="text-sm text-gray-500">
                    {doctorDetail[0]?.specializationName}
                  </p>
                  <p className="text-sm text-[#184A84] ">
                    {doctorDetail[0]?.location}
                  </p>
                </div>
              </div>
            </div>

            {/* Appointment Details */}
            <div className="p-4 border rounded-lg">
              <h3 className="text-center text[14px] text-[#606060] font-semibold mb-2">
                Appointment Details
              </h3>
              <p className="flex justify-between text-[16px] mt-5">
                <span>Type of Consultation</span>{" "}
                <span className="font-semibold"> Video Consultation</span>
              </p>
              <p className=" flex justify-between  mt-3">
                <span>Timings</span>{" "}
                <span className="text-[14px] font-semibold">
                  {formattedDate}, {formattedTime}
                </span>
              </p>
            </div>

            {/* Patient Details */}
            <div className="p-5 border rounded-lg ">
              <h3 className="text-center text[14px] text-[#606060] font-semibold mb-2">
                Patient Details
              </h3>
              <p className="flex justify-between  text-[16px]">
                <span>Name</span>{" "}
                <span className="font-semibold">{patient.patientName}</span>
              </p>
              <p className="flex justify-between mt-3 text-[16px]">
                <span>Age</span> <span className="font-semibold">{age}</span>
              </p>
            </div>

            {/* Total Charges */}
            <div className="px-5 py-4 border rounded-lg bg-[#009A8526]">
              <h3 className="text-center text[14px] text-[#606060] font-semibold ">
                Total Charges
              </h3>
              <p className="text-[16px] flex justify-between mt-3">
                <span>Consultation Fee</span>
                <span className="font-semibold text-[16px]">
                  ₹{doctorDetail[0]?.doctorFees}
                </span>
              </p>
              <p className="text-[16px] flex justify-between mt-2">
                <span>Booking Fee</span>
                <span className="font-semibold">₹0</span>
              </p>
              <hr className="border-t-1 border-gray-400 mt-1" />

              <p className="text-[16px] flex justify-between font-semibold mt-1">
                <span className="italic">Total Payable</span>
                <span className="text-[#009A85]">
                  ₹{doctorDetail[0]?.doctorFees}
                </span>
              </p>
            </div>
          </div>

          {/* Proceed to Payment Button */}
          <div className="flex flex-col sm:flex-row justify-end gap-4 xs:gap-10 mt-4 text-end">
  <div className="flex flex-col items-start sm:items-end gap-1">
  <div className="flex items-start sm:items-center gap-2">
      <input
        type="checkbox"
        id="terms"
        checked={isChecked}
        onChange={(e) => {
          setIsChecked(e.target.checked);
          if (e.target.checked) setError("");
        }}
        className="mr-2"
      />
      <label htmlFor="terms" className="text-sm xs:text-base">
        I agree to the{" "}
        <Link to="/terms_conditions" className="text-[#009A85] underline">
          terms and conditions
        </Link>
      </label>
    </div>
    {error && <p className="text-red-600 text-xs mt-1">{error}</p>}
  </div>
  <button
    onClick={handleClick}
    disabled={isLoading}
    className={`flex items-center justify-center gap-2 py-2 xs:px-4 rounded-lg text-white w-full sm:w-auto ${
      isLoading ? "bg-gray-400 cursor-not-allowed" : "bg-[#009A85]"
    }`}
  >
    {isLoading ? (
      <>
        Appointment Booking
        <svg
          className="animate-spin h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          ></path>
        </svg>
      </>
    ) : (
      "Book Appointment"
    )}
  </button>
</div>

        </div>

      </div>
    </div>
  );
};
export default DoctorCheckOut;
